import React, { Dispatch, SetStateAction } from 'react';

import { AccountInfoCard, NameForm } from '@components';
import { Modal, Typography } from 'gd-design-library';

interface AccountCustomerNameProps {
  firstName: string;
  lastName: string;
  modalOpened: boolean;
  setModalOpened: Dispatch<SetStateAction<boolean>>;
  handleSave: (firstName: string, lastName: string) => Promise<void>;
  isSaveLoading: boolean;
}

export const AccountCustomerName: React.FC<AccountCustomerNameProps> = ({
  firstName,
  lastName,
  modalOpened,
  setModalOpened,
  handleSave,
  isSaveLoading
}) => {
  const openModal = (): void => setModalOpened(true);
  const closeModal = (): void => setModalOpened(false);

  return <div>
    <AccountInfoCard onEdit={ openModal } title='Customer Name'>
      <Typography>
        { `${firstName} ${lastName}` }
      </Typography>
    </AccountInfoCard>
    <Modal isOpen={ modalOpened } onClose={ closeModal } title='Edit Name'>
      <NameForm
        onSave={ handleSave }
        initialFirstName={ firstName }
        initialLastName={ lastName }
        isLoading={ isSaveLoading }
      />
    </Modal>
  </div>;
};
